@if (isLoading()) {
	<app-mat-spinner spinnerClass="full-overlay" color="primary" />
}

@if (keycloak.authenticated) {
	<div class="flex flex-col h-screen w-screen">
		<app-admin-header />
		<div class="flex flex-1 transition-all overflow-hidden">
			<app-admin-side-menu [navLinks]="navLinks" />
			<div class="flex flex-col flex-1 overflow-y-auto" cdkScrollable>
				<app-container [isAuthenticated]="keycloak.authenticated" [isAdminApplication]="true">
					<router-outlet />
				</app-container>
			</div>
		</div>
	</div>
}
<app-cookie-consent />
<app-version-mismatch-modal />
